<mat-card appearance="outlined" class="email-preview-card">
  @if (shouldShowDropdown$ | async) {
    <form [formGroup]="selectTemplate">
      <mat-form-field>
        <mat-select
          placeholder="{{ 'SETTINGS.TEMPLATE_SETTINGS.CHOOSE_TEMPLATE' | translate }}"
          formControlName="select"
        >
          @for (template of previewTemplates$ | async; track template.templateId) {
            <mat-option [value]="template.templateId">
              {{ 'title' in template ? template.title : '' }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  }
  @if ((shouldShowDropdown$ | async) && isPreviewLoading) {
    <div class="stencil template-loading"></div>
  }
  <glxy-email-viewer
    [html]="previewHtml"
    [showDevicePreviewSizeButtons]="false"
    class="email-viewer"
  ></glxy-email-viewer>
</mat-card>
